import styled from 'styled-components'

export const Label = styled.label`
    padding-right: 1%;
    font-weight: 600;
    margin: 0;
`
